import React from "react";

import PopupContentBox from "../../components/PopupContentBox";
import KovaaksLogo from '../../assets/images/logo.svg'

const ResetPwdSuccessBody = () => (
  <div className="password-form-inner">
    <div className="password-form-header">
      <div className="header-content-wrapper">
        <div className="header-title">
          <span>Password Changed</span>
        </div>
        <div className="header-subtitle">
          <span>Get back in there!</span>
        </div>
      </div>
      <div className="header-logo-wrapper">
        <img src={KovaaksLogo} alt="" className="header-logo" />
      </div>
    </div>
    <div className="password-form-content">
      <PopupContentBox>
        <div className="password-form-content-main">
          <div className="password-form-text">
            Login into KovaaK's or <a href="https://kovaaks.com">KovaaKs.com</a> with your new password!
          </div>
        </div>
      </PopupContentBox>
    </div>
  </div>
);

export default ResetPwdSuccessBody;
